import React, { useEffect, useState } from "react";
import {
    INITIAL_DEL_ITEM } from "./RestBillConstants";
import { colors,
    TextField } from "../../ui";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import DialogBox from "../../global/DialogBox";
import { useDispatch,
    useSelector } from "react-redux";
import {
  addDeletedBillItem,
    removeItemFromBill,
    } from "../../../store/billDetailsSlice";
import {
  getAuthSession,
  DEL_ITEM_BILL,
  DELETEREASON,
  GENERATEBILL,
  isEmpty,
  NOITEMSAVAILABLE,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";

const BillItemDelete = ({ deleteItemData, setDeleteItemData }) => {
  //const [deleteItemData, setDeleteItemData] = useState({});
  const [deleteReason, setDeleteReason] = useState("");
  const { billItems, billDetails, billPaymentDetails } = useSelector(
    (state) => state.bill
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("deleteItemData: ", deleteItemData);
  });
  useEffect(() => {
    // console.log("showDialog: ", showDialog);
    console.log("showDialog from parent: ", deleteItemData.showDialog);
  }, [deleteItemData.showDialog]);

  const { snackbar, loader, dialog, notify } = useSnpUI();
  const deleteReasonConfigEnabled = getConfigValueByKey(
    restoBillConfig,
    DELETEREASON
  );
  const genBillOtpConfigEnabled = getConfigValueByKey(
    restoBillConfig,
    GENERATEBILL
  );
  const [generateBillOtp, setGenerateBillOtp] = useState("");
  const handleDialogClose = () => {
    setDeleteItemData({ ...deleteItemData, showDialog: false });
  };
  const deleteFromBill = async (productId) => {
    let error = false;
    if (deleteReason && isEmpty(deleteReason)) {
      error = true;
      // setSnpComponent({
      //   ...snpComponent,
      //   snackBarMsg: "Enter Reason for delete",
      //   snackBarOpen: true,
      // });
      snackbar.show({ message: "Enter Reason for delete", color: "warning" });
    }

    if (!error && !isEmpty(billDetails.billNo)) {
      let deleteUrl = storeApiUrl.BACKEND_BASE_URL + DEL_ITEM_BILL;
      let data = {
        jcJson: {
          value: getAuthSession().apiToken,
          value_1: productId,
          shopHash: storeActiveShopHash.id,
          value_2: billDetails.billNo,
          delMsg: deleteReason,
        },
      };
      loader.show();
      //setDeleteItemData(INITIAL_DEL_ITEM);
      setDeleteReason("");
      snpAxios
        .post(deleteUrl, data)
        .then((response) => {
          printDebugLog("response  => ", response.data.jcJson);
          if (
            response.data.status === SUCCESS ||
            response.data.status === NOITEMSAVAILABLE
          ) {
            deleteItemFromState(productId);
            handleDialogClose();
            snackbar.show({
              message: deleteItemData.productName + " deleted successfully",
              color: "orange",
              vertical: "top",
              horizontal: "right",
            });
          }
        })
        .catch((error) => {
          loader.hide();
          //printLog("errr ", error);
          //window.location.href = "#/error";
        });
    }
    loader.hide();
    handleDialogClose();
  };

  const deleteItemFromState = (productId) => {
    var index = billItems.findIndex(
      (singleValue) => singleValue.prdId === productId
    );
    if (index !== -1) {
      printDebugLog("deleting Item index", index, billItems[index]);
      // doTotal ??

      const oldPrice = billItems[index].finalPrice;
      dispatch(removeItemFromBill(billItems[index]));
      dispatch(addDeletedBillItem(billItems[index]));
      dispatch(
        recalculateBillTotal({ prevTotalPrice: oldPrice, newTotalPrice: 0 })
      );
    }
  };

    const handleGenerateBillOtpCheck = () => {
        if (
          isEmpty(generateBillOtp) ||
          generateBillOtp !== billDetails.generateOtp
        ) {
          snackbar.show({ message: "Please enter valid OTP", color: "red" });
        } else {
          deleteFromBill(deleteItemData.productId)
          handleDialogClose(false);
          setGenerateBillOtp("");
        }
    };

  const buildGenOtpUi = () => {
      return (
        <div>
        <TextField
          id="otp"
          name="otp"
          variant="filled"
          size="small"
          label={"Enter OTP"}
          defaultValue={generateBillOtp}
          onChange={(e) => setGenerateBillOtp(e.target.value)}
          style={{ width: "100%" }}
        />
        </div>
      );
    };
  
  const renderDeleteItemContent = () => {
    return (
      <>
        <p
          style={{
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
            fontSize: "16px",
          }}
        >
          {"Do you want to delete " + deleteItemData.productName}
        </p>
        {genBillOtpConfigEnabled && !isEmpty(billDetails.generateOtp) && buildGenOtpUi()}
        {deleteReasonConfigEnabled && (
          <div style={{ marginTop: "20px" }}>
          <TextField
            id="delReason"
            required
            name="delReason"
            variant="filled"
            size="small"
            label={"Enter Reason For Delete"}
            defaultValue={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            style={{ width: "100%" }}
          />
          </div>
        )}
       
      </>
    );
  };

  const renderrDeleteItemActions = () => {
    return (
      <>
        <SnpButton
          variant="contained"
          color="primary"
          onClick={() => genBillOtpConfigEnabled && !isEmpty(billDetails.generateOtp) ? handleGenerateBillOtpCheck() : deleteFromBill(deleteItemData.productId)}
        >
          Delete
        </SnpButton>
        <DismissButton
          variant="contained"
          color="primary"
          onClick={handleDialogClose}
        >
          Dismiss
        </DismissButton>
      </>
    );
  };

  return (
    <div>
      <DialogBox
        showDialog={deleteItemData.showDialog}
        title="Delete Item"
        onCLose={handleDialogClose}
        dialogContent={renderDeleteItemContent()}
        dialogActions={renderrDeleteItemActions()}
      ></DialogBox>
    </div>
  );
};

export default BillItemDelete;
